import { SET_ATLAS_IMAGE_ANIM, SET_ATLAS_JSON_ANIM, RESET_ATLAS_ANIM, SET_ATLAS_ANIM_ANIM } from "../../Actions/Animator/atlas.anim.action";
import { RESET_ALL } from "../../Actions/globals.actions";

const defaultAtlasData: any = {
    image: {},
    json: '',
    animation: ''
};

const atlasAnim = (state = defaultAtlasData, action: any ) => {
    switch (action.type) {
        case SET_ATLAS_IMAGE_ANIM: {
            return {
                ...state,
                image: action.payload
            };
        } 
        case SET_ATLAS_JSON_ANIM: {
            return {
                ...state,
                json: action.payload
            };
        } 
        case SET_ATLAS_ANIM_ANIM: {
            return {
                ...state,
                animation: action.payload
            };
        } 
        case RESET_ATLAS_ANIM: {
            return defaultAtlasData;
        }
        
        case RESET_ALL: {
            return defaultAtlasData;
        }

        default: 
            return state;
    }
}

export default atlasAnim;